import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
} from '@angular/router';
import {
    forkJoin as observableForkJoin,
    Observable,
} from 'rxjs';
import {
    map,
    take,
} from 'rxjs/operators';

import { IAccountSettings } from '../../account/shared/settings-jobs-assignment-account.model';
import { SettingsJobsAssignmentAccountService } from '../../account/shared/settings-jobs-assignment-account.service';
import { SettingsJobsAssignmentPrintModeService } from '../../print-mode/shared/settings-jobs-assignment-print-mode.service';
import { ISettingsPrintMode } from '../../print-mode/shared/settings-print-mode.model';

@Injectable()
export class NotAllowDisplayNameGuardService implements CanActivate {

    constructor(
        private accountService: SettingsJobsAssignmentAccountService,
        private printModeService: SettingsJobsAssignmentPrintModeService,
        private router: Router,
    ) { }

    public canActivate(): Observable<boolean> {
        const getAccountSettings: Observable<IAccountSettings> = this.accountService.getAccountSettings();
        const getPrintMode: Observable<ISettingsPrintMode> = this.printModeService.getPrintModeSettings();

        return observableForkJoin([getAccountSettings, getPrintMode]).pipe(
            take(1),
            map((results: any[]) => {
                if (results[0].isAccountSelectable || results[1].type) { return true; }

                this.router.navigate(['page-forbidden']);

                return false;
            }));
    }
}
